import TRIGGERS from './Triggers';
import PUNCTUATION from './Punctuation';

const VALID_CHARS = '[^' + TRIGGERS + PUNCTUATION + '\\s]';

export default VALID_CHARS;
